import {
    DataHeader,
    DataSourceMode, DataSourceModeChangeEvent, DropdownItem, DropdownSelectionEvent, Textbox
} from "@mcleod/components";
import { AutogenLayoutEquipmentTypeMaster } from "./autogen/AutogenLayoutEquipmentTypeMaster";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

const dropdownTractor = new DropdownItem("T", "Tractor");
const dropdownTrailer = new DropdownItem("L", "Trailer");
const dropdownTractorItem = new DropdownItem("Y", "Tractor Item");
const dropdownTrailerItem = new DropdownItem("X", "Trailer Item");
const dropdownDriverItem = new DropdownItem("D", "Driver Item");
const dropdownVan = new DropdownItem("V", "Van");
const dropdownReefer = new DropdownItem("R", "Reefer");
const dropdownFlat = new DropdownItem("F", "Flat");
const dropdownOther = new DropdownItem("O", "Other");

const viewEquipTypeURL = "lme/dispatch/EquipmentTypeMaster?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "equipment_type",
    screenName: "Equipment Type",
    navigateToUrl: viewEquipTypeURL
}

export class EquipmentTypeMaster extends AutogenLayoutEquipmentTypeMaster {
    override onLoad() {
        this.textboxAppliesTo.items = [
            dropdownTractor,
            dropdownTrailer,
            dropdownTractorItem,
            dropdownTrailerItem,
            dropdownDriverItem
        ];

        this.textboxExchangeType.items = [ dropdownVan, dropdownReefer, dropdownFlat, dropdownOther ];
        this.textboxAppliesTo.addAfterDropdownSelectionListener((event: DropdownSelectionEvent) => {
            this.textboxAppliesToOnChange(event.selection?.value)
        });
        
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS)
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    enableTrailerFields() {
        this.enableTextBox(this.textboxEquipLength);
        this.enableTextBox(this.textboxEquipWidth);
        this.enableTextBox(this.textboxPnnCodeId);
        this.textboxExchangeType.required = true;
        this.enableTextBox(this.textboxExchangeType);
        this.enableTextBox(this.textboxWebOrder);
    }

    disableAndClearTrailerFields() {
        this.resetTextbox(this.textboxEquipLength);
        this.resetTextbox(this.textboxEquipWidth);
        this.resetTextbox(this.textboxPnnCodeId);
        this.textboxExchangeType.required = false;
        this.resetTextbox(this.textboxExchangeType);
        this.resetTextbox(this.textboxWebOrder);
    }

    sourceEquipmentTypeAfterModeChange(event: DataSourceModeChangeEvent) {
        if (event.newMode == DataSourceMode.ADD) {
            this.textboxId.visible = true;
            this.textboxDescr.visible = true;
            this.textboxAppliesTo.visible = true;

            this.textboxEquipLength.visible = false;
            this.textboxEquipWidth.visible = false;
            this.textboxPnnCodeId.visible = false;
            this.textboxExchangeType.visible = false;
            this.textboxWebOrder.visible = false;
        }
        else {
            this.textboxAppliesToOnChange(this.activeRow?.get("applies_to"));
        }
    }

    private resetTextbox(textBox: Textbox): void {
        textBox.enabled = false;
        textBox.text = "";
        textBox.visible = false;
    }

    private enableTextBox(textBox: Textbox): void {
        textBox.enabled = true;
        textBox.visible = true;
    }

    private textboxAppliesToOnChange(appliesTo: string) {
        appliesTo === dropdownTrailer.value ? this.enableTrailerFields() : this.disableAndClearTrailerFields();
    }
}
